import { init, LanguageDetectorModule, use } from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from 'cleverev-whitelabel/hub/default/locales/en.json'


// Use a language detector to cache the user's chosen language or fall back to the browser's language
const languageCacheKey = '@cleverev-manage/language'
use<LanguageDetectorModule>({
  type: 'languageDetector',
  init: () => null,
  detect: (): string => {
    const detectedLanguage = window.navigator.language
    const cachedLanguage = window.localStorage.getItem(languageCacheKey)

    return cachedLanguage ?? detectedLanguage
  },
  cacheUserLanguage: (language: string): void => {
    window.localStorage.setItem(languageCacheKey, language)
  }
})

// Use the react-i18next module for react compatibility
use(initReactI18next)

// Default language and namespace
const defaultLng = 'en'
const defaultNS = 'translation'

// Load language resources as constant
const resources = {
  en: { [defaultNS]: en }
} as const

// Initialize i18next
init({
  compatibilityJSON: 'v3',
  defaultNS,
  fallbackLng: defaultLng,
  interpolation: {
    escapeValue: false
  },
  ns: [ defaultNS ],
  resources
})

export { defaultLng, defaultNS, resources }
